<template>
  <div class="library">
    <div class="title">资源库</div>
    <div class="cont">
      <div class="c-t" @click="() => { this.$router.push({ name: 'MyLibrary' }) }">
        <img src="../../assets/image/back.png" alt="">
        <span>返回我的资源库</span>
      </div>
      <div class="m-t"> 我的共享 </div>
      <div class="c-c">
        <div class="c-c-l">
          <span class="cancel-share" @click="cancelShareFun">取消共享</span>
        </div>
        <div class="c-c-r">
          <a-input-search v-model="shareFileName" placeholder="请输入文件名" size="small" style="width: 180px"
                          @search="onSearch" />
        </div>
      </div>
      <div class="c-b">
        <span @click="pageHeaderListFn(item)" :class="{ 'allWj': item.id === 0 }" class="pageHeaderList"
              v-for="item in pageHeaderList" :key=item.id> <span v-if="item.id !== 0">></span> {{
            item.fileName
          }}</span>
      </div>
      <div class="table">
        <a-table :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
                 :rowKey="(record, index) => {return index}" :columns="columns" :data-source="dataList"
                 :pagination="false">
          <span class="file-name" slot="fileName" slot-scope="text,record">
            <img class="img" v-if="record.isFolder === 0" src="../../assets/image/file folder_yellow.png"
                 alt="" />
            <img class="img" v-else-if="record.fileType === 1" src="../../assets/image/img.png" alt="">
            <img class="img" v-else-if="record.fileType === 2" src="../../assets/image/music.png" alt="">
            <img class="img" v-else-if="record.fileType === 3" src="../../assets/image/mov.png" alt="">
            <img class="img" v-else-if="record.fileType === 4" src="../../assets/image/file.png" alt="">
            <img class="img" v-else src="../../assets/image/unknow_type.png" alt="">
            <span class="file-name-t" :title="record.fileName"
                  @click="goFileList(record)">{{ record.fileName }}</span>
          </span>
          <span slot="fileSize" slot-scope="text,record">{{ record.fileSize | filterType }}</span>
          <span slot="createDate" slot-scope="text,record">{{ format.format(record.createDate) }}</span>
          <template slot="operation" slot-scope="text,record">
            <div v-if="parentId=='0'" class="editable">
              <span @click="shareCancel(record)">取消共享</span>
            </div>
          </template>
        </a-table>
        <div class="page-bot">
          <div class="left">共{{ total || 0}}条数据</div>
          <div class="right">
            <a-config-provider>
              <a-pagination show-quick-jumper size="small" :current="pageNum" :page-size="pageSize"
                            @change="handleListChange" show-less-items :total=total />
            </a-config-provider>
          </div>
        </div>
      </div>
    </div>
    <a-modal title="取消共享提醒" :visible="plshareVis" @cancel="() => { this.plshareVis = false }" destroyOnClose
             width="460px" footer="">
      <div class="wj-new">
        <div class="del-text" style="margin-top: 15px">是否确认取消共享文件？ </div>
        <div class="del-text">取消后学生将无法看到该资源。</div>
      </div>
      <!-- <div class="remove-footer">
      <a-button class="cancel" @click="()=>{this.plshareVis = false;}">取消</a-button>
      <a-button type="danger" @click="plShareSure" class="remove-on">确认</a-button>
    </div> -->
      <div class="f-del">
        <div class="f-c" @click="() => { this.plshareVis = false }">取消</div>
        <div class="f-s" @click="plShareSure">确认</div>
      </div>
    </a-modal>
    <a-modal title="取消共享提醒" :visible="shareVis" @cancel="() => { this.shareVis = false }" width="460px"
             footer="">
      <div class="wj-new">
        <div class="del-text" style="margin-top: 15px">是否确认取消共享文件？ </div>
        <div class="del-text">取消后学生将无法查看下载。</div>
      </div>
      <!-- <div class="remove-footer">
      <a-button class="cancel" @click="()=>{this.shareVis=false}">取消</a-button>
      <a-button type="danger" @click="shareSure" class="remove-on">确认</a-button>
    </div> -->
      <div class="f-del">
        <div class="f-c" @click="() => { this.shareVis = false }">取消</div>
        <div class="f-s" @click="shareSure">确认</div>
      </div>
    </a-modal>
    <file-preview :visible.sync="imgView" v-if="imgView" :file="previewFile"></file-preview>
  </div>
</template>

<script>
import format from '@/utils/format.js';
import FilePreview from 'components/FilePreview';

export default {
  name: 'MyShareList',
  components: { FilePreview },
  data() {
    return {
      format,
      pageHeaderList: [{ fileName: '全部文件', id: 0 }],
      dataList: [],
      access_token: this.$store.state.access_token,
      columns: [],
      newVis: false,
      newName: '', // 文件夹名称
      removeVis: false, // 移动弹窗
      value: 2,
      radioStyle: {
        display: 'block',
        height: '40px',
        lineHeight: '40px',
        width: '100%',
      },
      shareVis: false,
      plshareVis: false,
      pageSize: 10,
      pageNum: 1,
      total: 0,
      fileId: 0,
      reNameVis: false,
      editNameMess: {},
      classListSelected: [], // 单个共享班级
      allClassListSelected: [], // 批量资源共享班级
      dirRootId: '',
      folderFlag: false,
      parentId: '0',
      folderName: '',
      shareMess: JSON.parse(sessionStorage.getItem('shareMess')),
      teacherId: this.$store.state.userId || JSON.parse(localStorage.getItem('user_info')).id,
      cancelShare: {},
      shareList: [],
      selectedRowKeys: [],
      selectedRowsList: [],
      previewFile: { name: '', url: '' },
      fileName: '',
      shareFileName: '',
      imgView: false,
      videoList: [],
      isSearch: false,
    };
  },
  mounted() {
    // 默认应该都是我的共享所有资源列表，parentId：0
    // this.parentId = this.shareMess.parentId;

    this.getDataList();
    this.columns = [
      {
        title: '文件名',
        dataIndex: 'fileName',
        key: 'fileName',
        scopedSlots: { customRender: 'fileName' },
        ellipsis: true,
      },
      {
        title: '浏览',
        dataIndex: 'viewCount',
        key: 'viewCount',
        scopedSlots: { customRender: 'viewCount' },
        width: 100,
        align: 'center',
      },
      {
        title: '大小',
        dataIndex: 'fileSize',
        key: 'fileSize',
        scopedSlots: { customRender: 'fileSize' },
        width: 140,
        align: 'center',
      },
      // {
      //   title: '',
      //   dataIndex: 'fileType',
      //   key: 'fileType',
      //   scopedSlots: { customRender: 'fileType' },
      //   width: 60
      // },
      {
        title: '下载',
        dataIndex: 'downloadCount',
        key: 'downloadCount',
        width: 100,
        align: 'center',
      },
      {
        title: '共享时间',
        dataIndex: 'createDate',
        key: 'createDate',
        scopedSlots: { customRender: 'createDate' },
        width: 170,
        align: 'center',
      },
      {
        title: '操作',
        dataIndex: 'operation',
        scopedSlots: { customRender: 'operation' },
        align: 'center',
      },
    ];
  },
  methods: {
    clearData() {
      this.selectedRowKeys = []; // 调用这个方法就有效果了
      this.$forceUpdate();
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    getDataList(param) {
      if (param == null) {
        param = {
          id: this.parentId,
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          teacherId: this.teacherId,
          access_token: this.access_token,
          fileName: this.isSearch ? this.shareFileName : '',
        };
      }

      this.$fetch({
        url: this.$httpConfig.getSharePage,
        body: param,
      }).done((res) => {
        // console.log(res);
        // todo 注意 接口返回参数  isFolder  0：文件夹  1：文件
        if (res && res.success && res.resultData) {
          this.dataList = res.resultData.list;
          this.total = res.resultData.total;
          this.clearData();
        }
      });
    },
    goAllData() {
      this.folderFlag = false;
      this.fileType = '';
      this.fileId = 0;
      this.parentId = '0';
      this.getDataList();
    },

    pageHeaderListFn(item) {
      // console.log(item, 'item');
      const index = this.pageHeaderList.findIndex((v) => v.id === item.id);
      this.pageHeaderList.splice(index + 1);
      this.fileId = item.id;
      const param = {
        id: this.fileId,
        fileName: this.isSearch ? this.searchFileName : '',
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        fileType: this.fileType,
        teacherId: this.teacherId,
      };
      this.parentId = item.id;
      this.getDataList(param);
    },

    goFileList(item) {
      // console.log(item);
      // if (item.isNext === 0 && item.isFolder !== 1) {
      //   this.$message.warning('空文件夹');
      //   return;
      // }
      this.folderFlag = item.isFolder === 0;
      if (item.isFolder === 0) {
        this.pageHeaderList.push(item);
      }

      if (item.isFolder === 1) {
        // 预览功能
        this.updateViewCount(item);
        this.imgView = true;
        this.previewFile = { name: item.fileName, url: this.$resBasePath + '/' + item.filePath };
      } else if (item.isFolder === 0) {
        this.updateViewCount(item);
        this.pageNum = 1;
        this.imgView = false;
        this.folderFlag = true;
        this.parentId = item.id;
        // console.log(this.parentId);
        this.folderName = item.fileName;
        this.fileName = item.fileName;
        this.fileId = item.id;
        this.getDataList();
      } else {
        this.$message.warning('此文件暂不支持预览');
      }
    },
    cancelShareFun() {
      if (this.folderFlag) {
        this.$message.warn('共享文件夹下文件不允许取消共享');
        return;
      }
      if (this.selectedRowKeys.length === 0) {
        this.$message.warning('请您选择需要取消共享的文件');
        return;
      }
      this.plshareVis = true;
    },
    onChange(e) {
      console.log(e);
    },
    onSearch() {
      this.isSearch = true;
      this.pageNum = 1;
      this.getDataList();
    },
    remove() {
      this.removeVis = true;
    },
    shareCancel(item) {
      if (this.folderFlag) {
        this.$message.warn('单个文件呢不允许取消');
        return;
      }
      this.cancelShare = item;
      this.shareVis = true;
    },
    reName(item) {
      this.editNameMess = JSON.parse(JSON.stringify(item));
      this.reNameVis = true;
    },
    plShareSure() {
      if (this.total === 0) {
        return;
      }
      for (const key of this.selectedRowKeys) {
        this.selectedRowsList.push(this.dataList[key]);
      }
      const ids = [];
      this.selectedRowsList.forEach((item) => {
        ids.push(item.id);
      });
      const param = {
        ids: ids,
        access_token: this.access_token,
      };
      this.$fetch({
        url: this.$httpConfig.cancelShare,
        body: param,
      }).done((res) => {
        if (res && res.success) {
          this.$message.success('取消成功');
          this.getDataList();
          this.plshareVis = false;
        }
      });

      // this.getDataList()
    },
    // onChange (checkedValues) {
    //   console.log('checked = ', checkedValues)
    // },
    classChange(e) {
      this.classListSelected = e;
      console.log(e);
    },
    allClassChange(e) {
      this.allClassListSelected = e;
      console.log(e);
    },
    shareSure() {
      const param = {
        ids: [this.cancelShare.id],
        access_token: this.access_token,
      };

      this.$fetch({
        url: this.$httpConfig.cancelShare,
        body: param,
      }).done((res) => {
        if (res && res.success) {
          this.$message.success('取消成功');
          this.getDataList();
          this.shareVis = false;
        }
      });
    },
    handleListChange(current, pagesize) {
      // console.log(current, pagesize);
      this.pageNum = current;
      this.pageSize = pagesize;
      this.getDataList();
    },
    updateViewCount(item) {
      const param = {
        id: item.id,
        type: 1, // 更新类型 1：更新浏览量加1 ， 2：更新下载量加1
      };
      this.$fetch({
        url: this.$httpConfig.updateTeaResourceViewOrDownLoadCount,
        body: param,
      }).done((res) => {
        if (res && res.success) {
          item.viewCount += 1;
        } else {
          this.$message.warn('更新浏览量失败');
        }
      });
    },
  },

  watch: {
    // 搜索内容改变时，置为false，点击搜索时isSearch=true
    shareFileName() {
      this.isSearch = false;
    },
  },
  filters: {
    filterType: function (val) {
      if (val === null) return '';
      if (val === 0) return '0 B';
      var k = 1024;
      var sizes = ['B', 'KB', 'MB', 'GB', 'PB', 'TB', 'EB', 'ZB', 'YB'];
      var i = Math.floor(Math.log(val) / Math.log(k));
      return (val / Math.pow(k, i)).toPrecision(3) + '' + sizes[i];
    },
  },
};
</script>

<style lang="less" scoped>
.pageHeaderList {
  margin-left: 6px;
  margin-right: 6px;
  cursor: pointer;
}

.pageHeaderList:hover {
  color: @primary-color;
}

ul,
li {
  list-style: none;
  margin: 0;
  padding: 0;
}

.library {
  .title {
    color: #333;
    font-size: 16px;
    border-bottom: 1px solid #f2f2f2;
    text-indent: 30px;
    height: 50px;
    line-height: 50px;
    font-weight: 600;
  }

  .cont {
    padding: 20px 30px;

    .c-t {
      height: 40px;
      color: @primary-color;
      font-size: 14px;
      display: flex;
      cursor: pointer;

      img {
        width: 18px;
        height: 18px;
        margin-top: 2px;
      }
    }

    .m-t {
      color: #000;
      font-size: 16px;
      font-weight: 600;
    }

    .c-c {
      display: flex;
      margin-top: 10px;

      .c-c-l {
        flex: 12;

        .cancel-share {
          display: inline-block;
          width: 80px;
          height: 20px;
          line-height: 20px;
          text-align: center;
          color: #fff;
          background: @primary-color;
          // background: rgba(216, 165, 101, .4);
        }

        span {
          display: inline-block;
          width: 60px;
          height: 24px;
          line-height: 24px;
          text-align: center;
          cursor: pointer;
          border-radius: 2px;
        }

        .typeNormal {
          color: #666;
          // padding: 0 5px;
        }

        .typeActive {
          background: @primary-color;
          color: #fff;
          // padding: 0 5px;
        }
      }

      .c-c-r {
        flex: 12;
        text-align: right;

        /deep/.ant-input {
          border-radius: 4px;
        }
      }
    }

    .c-b {
      margin-top: 15px;

      .allWj {
        color: @primary-color;
        cursor: pointer;
      }

      .img {
        width: 16px;
        height: 16px;
        margin: -2px 3px 0px 3px;
      }
    }

    .table {
      margin-top: 10px;

      .share {
        display: inline-block;
        background: #f7ede0;
        width: 60px;
        height: 24px;
        line-height: 24px;
        text-align: center;
        color: @primary-color;
        font-size: 14px;
        border-radius: 10px;
        cursor: pointer;
      }

      .editable {
        span {
          color: @primary-color;
          margin-left: 10px;
          cursor: pointer;
        }
      }

      .file-name {
        display: flex;

        .img {
          width: 20px;
          height: 20px;
          margin-right: 8px;
        }
      }

      .file-name-t {
        cursor: pointer;
      }
    }
  }
}

.wj-ul {
  width: 100%;

  /deep/.ant-radio-group {
    width: 100% !important;
  }

  .wj-li {
    display: flex;
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #edeef1;

    .wj-img {
      width: 20px;
      height: 20px;
    }

    .wj-name {
      font-size: 14px;
      color: #797979;
      margin-left: 15px;
    }
  }
}

.f-del {
  display: flex;
  margin-top: 20px;

  justify-content: center;
  div {
    width: 80px;
    height: 24px;
    line-height: 24px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    border-radius: 2px;
    text-align: center;
    cursor: pointer;
  }

  .f-c {
    background: #ffffff;
    border: 1px solid #dbd1cd;
    color: #867d7b;
  }

  .f-s {
    background: @primary-color;
    color: #fff;
    margin-left: 20px;
  }

  .danger {
    background: red;
    color: #fff;
    font-size: 16px;
  }
}

/deep/.ant-modal-body {
  padding: 0 24px 24px;
}

.wj-new1 {
  margin-top: 20px;

  /deep/.ant-input {
    border-radius: 2px;
  }
}

.wj-new {
  margin-top: 20px;
  margin: 20px auto;
  text-align: center;

  //   width: 100px;
  .del-img {
    width: 50px;
    height: 50px;
  }

  .del-text {
    line-height: 20px;
    color: #666;
    font-size: 14px;
  }

  /deep/.ant-upload {
    margin-left: auto;
  }
}

.share-m {
  margin-top: 15px;
  height: 40px;
  line-height: 40px;
  border-bottom: 2px dotted #f9f9f9;
}

.page-bot {
  display: flex;
  height: 50px;
  line-height: 50px;

  .left {
    margin-top: 5px;
  }

  .right {
    margin-left: auto;
    text-align: right;
    margin-top: 20px;
  }
}

/deep/.ant-table-thead > tr > th {
  border: none;
}

/deep/.ant-table-tbody > tr {
  border-bottom: 1px solid #e8e8e8 !important;
}

/deep/.ant-table-tbody > tr > td {
  border: none;
  border-bottom: 1px solid #e8e8e8 !important;
}

.viewDom {
  text-align: center;
  min-height: 500px;
  padding: 20px;
  max-width: 1000px;
  line-height: 500px;

  img {
    max-width: 1000px;
  }
}
</style>
